import React from 'react';

function Cases() {
  return (
    <section className="tc-cases-style10 section-padding-x section-padding">
      <div className="container-fluid">
        <div className="title mb-50">
          <div className="row align-items-end">
            <div className="col-lg-6">
              <div className="section-head-style10 js-splittext-lines">
                <div className="sub-title mb-30"> our cases </div>
                <h2> Featured cases </h2>
              </div>
            </div>
            <div className="col-lg-6 text-lg-end mt-5 mt-lg-0">
              <div
                className="nav nav-pills wow fadeInUp slow justify-content-lg-end"
                data-wow-delay="0.4s"
                id="v-pills-tab"
              >
                <button
                  className="nav-link active"
                  id="v-pills-tab1-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-tab1"
                >
                  all
                </button>
                <button
                  className="nav-link"
                  id="v-pills-tab2-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-tab2"
                >
                  architecture
                </button>
                <button
                  className="nav-link"
                  id="v-pills-tab3-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-tab1"
                >
                  Landscape
                </button>
                <button
                  className="nav-link"
                  id="v-pills-tab4-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-tab2"
                >
                  Interior
                </button>
                <button
                  className="nav-link"
                  id="v-pills-tab3-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-tab1"
                >
                  Furniture
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="tab-content" id="v-pills-tabContent">
          <div className="tab-pane fade show active" id="v-pills-tab1">
            <div className="cases-content">
              <div className="row">
                <div className="col-lg-6">
                  <a
                    href="#"
                    className="case-item wow left_to_right_apperance no_scale"
                  >
                    <div className="img">
                      <img
                        src="/home10/assets/img/cases/case1.jpg"
                        alt=""
                        className="img-cover"
                      />
                    </div>
                    <div className="info">
                      <h5 className="fsz-40 mb-2"> Aston Martin Villa </h5>
                      <small className="fsz-12"> Architecture, Interior </small>
                    </div>
                    <span className="arrow">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
                <div className="col-lg-6">
                  <a
                    href="#"
                    className="case-item wow left_to_right_apperance no_scale"
                  >
                    <div className="img">
                      <img
                        src="/home10/assets/img/cases/case2.jpg"
                        alt=""
                        className="img-cover"
                      />
                    </div>
                    <div className="info">
                      <h5 className="fsz-40 mb-2"> B27 Apartment, Ohio </h5>
                      <small className="fsz-12"> Interior, Furniture </small>
                    </div>
                    <span className="arrow">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
                <div className="col-lg-12">
                  <a
                    href="#"
                    className="case-item th-600 wow left_to_right_apperance no_scale"
                  >
                    <div className="img">
                      <img
                        src="/home10/assets/img/cases/case3.jpg"
                        alt=""
                        className="img-cover"
                      />
                    </div>
                    <div className="info">
                      <h5 className="fsz-40 mb-2"> Boston Deon Mall </h5>
                      <small className="fsz-12"> Architecture </small>
                    </div>
                    <span className="arrow">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
                <div className="col-lg-6">
                  <a
                    href="#"
                    className="case-item wow left_to_right_apperance no_scale"
                  >
                    <div className="img">
                      <img
                        src="/home10/assets/img/cases/case4.jpg"
                        alt=""
                        className="img-cover"
                      />
                    </div>
                    <div className="info">
                      <h5 className="fsz-40 mb-2">
                        Luxury Furniture <br /> Bespoke
                      </h5>
                      <small className="fsz-12"> Interior, Furniture </small>
                    </div>
                    <span className="arrow">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
                <div className="col-lg-6">
                  <a
                    href="#"
                    className="case-item wow left_to_right_apperance no_scale"
                  >
                    <div className="img">
                      <img
                        src="/home10/assets/img/cases/case5.jpg"
                        alt=""
                        className="img-cover"
                      />
                    </div>
                    <div className="info">
                      <h5 className="fsz-40 mb-2"> Dash Private Villa </h5>
                      <small className="fsz-12">
                        Architecture, Interior, Furniture
                      </small>
                    </div>
                    <span className="arrow">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
                <div className="col-lg-6">
                  <a
                    href="#"
                    className="case-item wow left_to_right_apperance no_scale"
                  >
                    <div className="img">
                      <img
                        src="/home10/assets/img/cases/case6.jpg"
                        alt=""
                        className="img-cover"
                      />
                    </div>
                    <div className="info">
                      <h5 className="fsz-40 mb-2"> Miami Homestay </h5>
                      <small className="fsz-12"> Landscape, Interior </small>
                    </div>
                    <span className="arrow">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
                <div className="col-lg-6">
                  <a
                    href="#"
                    className="case-item wow left_to_right_apperance no_scale"
                  >
                    <div className="img">
                      <img
                        src="/home10/assets/img/cases/case7.jpg"
                        alt=""
                        className="img-cover"
                      />
                    </div>
                    <div className="info">
                      <h5 className="fsz-40 mb-2"> Container House </h5>
                      <small className="fsz-12">
                        {' '}
                        Architecture, Landscape{' '}
                      </small>
                    </div>
                    <span className="arrow">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="tab-pane fade" id="v-pills-tab2">
            <div className="cases-content">
              <div className="row">
                <div className="col-lg-6">
                  <a
                    href="#"
                    className="case-item wow left_to_right_apperance no_scale"
                  >
                    <div className="img">
                      <img
                        src="/home10/assets/img/cases/case1.jpg"
                        alt=""
                        className="img-cover"
                      />
                    </div>
                    <div className="info">
                      <h5 className="fsz-40 mb-2"> Aston Martin Villa </h5>
                      <small className="fsz-12"> Architecture, Interior </small>
                    </div>
                    <span className="arrow">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
                <div className="col-lg-6">
                  <a
                    href="#"
                    className="case-item wow left_to_right_apperance no_scale"
                  >
                    <div className="img">
                      <img
                        src="/home10/assets/img/cases/case2.jpg"
                        alt=""
                        className="img-cover"
                      />
                    </div>
                    <div className="info">
                      <h5 className="fsz-40 mb-2"> B27 Apartment, Ohio </h5>
                      <small className="fsz-12"> Interior, Furniture </small>
                    </div>
                    <span className="arrow">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
                <div className="col-lg-12">
                  <a
                    href="#"
                    className="case-item th-600 wow left_to_right_apperance no_scale"
                  >
                    <div className="img">
                      <img
                        src="/home10/assets/img/cases/case3.jpg"
                        alt=""
                        className="img-cover"
                      />
                    </div>
                    <div className="info">
                      <h5 className="fsz-40 mb-2"> Boston Deon Mall </h5>
                      <small className="fsz-12"> Architecture </small>
                    </div>
                    <span className="arrow">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
                <div className="col-lg-6">
                  <a
                    href="#"
                    className="case-item wow left_to_right_apperance no_scale"
                  >
                    <div className="img">
                      <img
                        src="/home10/assets/img/cases/case4.jpg"
                        alt=""
                        className="img-cover"
                      />
                    </div>
                    <div className="info">
                      <h5 className="fsz-40 mb-2">
                        Luxury Furniture <br /> Bespoke
                      </h5>
                      <small className="fsz-12"> Interior, Furniture </small>
                    </div>
                    <span className="arrow">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
                <div className="col-lg-6">
                  <a
                    href="#"
                    className="case-item wow left_to_right_apperance no_scale"
                  >
                    <div className="img">
                      <img
                        src="/home10/assets/img/cases/case5.jpg"
                        alt=""
                        className="img-cover"
                      />
                    </div>
                    <div className="info">
                      <h5 className="fsz-40 mb-2"> Dash Private Villa </h5>
                      <small className="fsz-12">
                        Architecture, Interior, Furniture
                      </small>
                    </div>
                    <span className="arrow">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
                <div className="col-lg-6">
                  <a
                    href="#"
                    className="case-item wow left_to_right_apperance no_scale"
                  >
                    <div className="img">
                      <img
                        src="/home10/assets/img/cases/case6.jpg"
                        alt=""
                        className="img-cover"
                      />
                    </div>
                    <div className="info">
                      <h5 className="fsz-40 mb-2"> Miami Homestay </h5>
                      <small className="fsz-12"> Landscape, Interior </small>
                    </div>
                    <span className="arrow">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
                <div className="col-lg-6">
                  <a
                    href="#"
                    className="case-item wow left_to_right_apperance no_scale"
                  >
                    <div className="img">
                      <img
                        src="/home10/assets/img/cases/case7.jpg"
                        alt=""
                        className="img-cover"
                      />
                    </div>
                    <div className="info">
                      <h5 className="fsz-40 mb-2"> Container House </h5>
                      <small className="fsz-12">
                        {' '}
                        Architecture, Landscape{' '}
                      </small>
                    </div>
                    <span className="arrow">
                      <i className="ti-arrow-top-right"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center">
          <a
            href="#"
            className="butn borderd border rounded-pill mt-80 hover-bg-black bg-white"
          >
            <span>
              See All Cases <i className="small ms-1 ti-arrow-top-right"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Cases;
